module.exports = __webpack_public_path__ + "img/11-onebg.a80c429c.jpg";